// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1BDZb","range":"MonthRangeSwitch_range__1DG_5","disabled":"MonthRangeSwitch_disabled__m3WNZ"};